import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : 'https://api.mykliniktools.de'; // Hier jetzt die neue Subdomain


function Auth({ onLogin }) {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [fullName, setFullName] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            if (isLogin) {
                // Login: FastAPI erwartet Form-Data (URLSearchParams)
                const formData = new URLSearchParams();
                formData.append('username', email);
                formData.append('password', password);

                const response = await axios.post(`${API_BASE_URL}/login`, formData);

                // Token UND Namen im Browser speichern
                localStorage.setItem('token', response.data.access_token);
                localStorage.setItem('userName', response.data.user_name);

                // App-State aktualisieren
                onLogin(response.data.access_token);
            } else {
                // Registrierung: Normales JSON
                await axios.post(`${API_BASE_URL}/register`, {
                    email: email,
                    password: password,
                    full_name: fullName
                });

                alert("Registrierung erfolgreich! Bitte loggen Sie sich jetzt ein.");
                setIsLogin(true);
            }
        } catch (err) {
            console.error("Auth Fehler:", err);
            setError(err.response?.data?.detail || "Ein Fehler ist aufgetreten. Prüfen Sie die Backend-Verbindung.");
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full border border-slate-200">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-slate-800">Klinik Portal</h2>
                    <p className="text-slate-500 mt-2">
                        {isLogin ? 'Bitte melden Sie sich an' : 'Erstellen Sie ein neues Konto'}
                    </p>
                </div>

                {error && (
                    <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded shadow-sm">
                        <p className="font-bold">Fehler</p>
                        <p>{error}</p>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-5">
                    {!isLogin && (
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-1">Voller Name</label>
                            <input
                                type="text"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                placeholder="Dr. Med. Mustermann"
                                required={!isLogin}
                            />
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-1">E-Mail Adresse</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                            placeholder="name@klinik.de"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-1">Passwort</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white font-bold py-3 rounded-lg hover:bg-blue-700 transform active:scale-95 transition-all shadow-md mt-4"
                    >
                        {isLogin ? 'Anmelden' : 'Konto erstellen'}
                    </button>
                </form>

                <div className="mt-8 pt-6 border-t border-slate-100 text-center">
                    <p className="text-slate-600">
                        {isLogin ? "Noch keinen Zugang?" : "Bereits ein Konto vorhanden?"}
                    </p>
                    <button
                        onClick={() => { setIsLogin(!isLogin); setError(''); }}
                        className="text-blue-600 hover:text-blue-800 font-bold mt-1 transition-colors"
                    >
                        {isLogin ? 'Jetzt registrieren' : 'Zum Login wechseln'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Auth;